import { StepInProgress, StepPending, StepCompleted } from "helper/images";
import "./styles.css";

export const StepsHeader = ({ step = 1, total = 3, labels }) => {
  const elements = [];

  for (let i = 1; i <= total; i++) {
    if (i < step) {
      elements.push(
        <>
          <div className="relative">
            <StepCompleted />
            <span className="absolute max-content adjust-item text-[10px] md:text-sm lg:text-sm font-semibold text-primary">
              {labels[i - 1]}
            </span>
          </div>
          {i !== total && <div className={`h-0.5 w-[25%] bg-[#652172]`} />}
        </>
      );
    } else if (i === step) {
      elements.push(
        <>
          <div className="relative">
            <StepInProgress />
            <span className="absolute max-content adjust-item text-[10px] md:text-sm lg:text-sm font-semibold text-primary">
              {labels[i - 1]}
            </span>
          </div>
          {i !== total && <div className={`h-0.5 w-[25%] bg-gradient-600`} />}
        </>
      );
    } else {
      elements.push(
        <>
          <div className="relative">
            <StepPending />
            <span className="absolute max-content adjust-item text-[10px] md:text-sm lg:text-sm font-semibold text-primary">
              {labels[i - 1]}
            </span>
          </div>
          {i !== total && <div className={`h-0.5 w-[25%] bg-gradient-600`} />}
        </>
      );
    }
  }

  return (
    <div className="flex row items-center justify-center w-[92%]">
      {elements}
    </div>
  );
};
